import { useCallback } from "react";
import { useTable, useTableActions } from "../TableContext";

/**
 * Hook pour gérer le tri avec toggle
 */
export const useTableSort = () => {
  const { state } = useTable();
  const { setSorting, clearSorting } = useTableActions();

  const toggleSort = useCallback((field: string) => {
    if (state.sortField === field) {
      // Si on trie déjà sur ce champ, inverser la direction
      if (state.sortDirection === 'asc') {
        setSorting(field, 'desc');
      } else if (state.sortDirection === 'desc') {
        // Si déjà desc, on clear le tri
        clearSorting();
      }
    } else {
      // Nouveau champ, commencer par asc
      setSorting(field, 'asc');
    }
  }, [state.sortField, state.sortDirection, setSorting, clearSorting]);

  const getSortIndicator = useCallback((field: string): '↑' | '↓' | '' => {
    if (state.sortField !== field) return '';
    return state.sortDirection === 'asc' ? '↑' : '↓';
  }, [state.sortField, state.sortDirection]);

  return {
    sortField: state.sortField,
    sortDirection: state.sortDirection,
    toggleSort,
    getSortIndicator,
    setSorting,
    clearSorting
  };
};
